import { render, staticRenderFns } from "./Proportional.vue?vue&type=template&id=2fa06117&scoped=true&"
import script from "./Proportional.vue?vue&type=script&lang=js&"
export * from "./Proportional.vue?vue&type=script&lang=js&"
import style0 from "./Proportional.vue?vue&type=style&index=0&id=2fa06117&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa06117",
  null
  
)

export default component.exports